import { IconMessage } from '@tabler/icons-react'

import { AstraBadge, AstraIcon, AstraParagraph } from '~/astra'
import { LocationScheduleActivityLog } from '~/storm'
import { getInitials } from '~/utils/user'

import { ActivityLogWrapper } from './ActivityLogWrapper'
import { formatDate, getActivityTypeLabel } from './utils'

const MessageBadgeIcon = () => (
    <div className="items-centerer flex grow justify-center">
        <AstraBadge size="large" icon={<AstraIcon icon={IconMessage} size="medium" />} />
    </div>
)

type Props = {
    activityLogEntry: LocationScheduleActivityLog
}

export const LocationScheduleActivityLogEntry = ({ activityLogEntry }: Props) => {
    const performedBy = activityLogEntry.performed_by ?? ''
    const initials = getInitials(performedBy)
    const activityTypeLabel = getActivityTypeLabel(activityLogEntry.activity_type)
    const comment = activityLogEntry.comment
    const performedAt = formatDate(activityLogEntry.performed_at)

    return (
        <ActivityLogWrapper icon={<MessageBadgeIcon />} performedBy={performedBy} initials={initials} performedAt={performedAt}>
            <div className="flex flex-col gap-1 pt-1">
                <AstraParagraph variant="body">
                    {activityTypeLabel} {activityTypeLabel === 'la til' ? 'en kommentar' : 'kommentaren'}
                </AstraParagraph>
                {comment && (
                    <AstraParagraph variant="body" className="italic text-muted">
                        "{comment}"
                    </AstraParagraph>
                )}
            </div>
        </ActivityLogWrapper>
    )
}
